/* eslint-disable semi */
/**
 * 全て許容するバリデータ
 * @param {*} rule
 * @param {*} value
 * @param {*} callback
 * @param {*} source
 * @param {*} options
 */
export function allowAll (rule, value, callback, source, options) {
  callback();
}



// WEBPACK FOOTER //
// ./src/core/rules/allow-all.js